import React, { useContext } from 'react'
import usePrevious from '../hooks/usePrevious'
import useImageEffect from '../hooks/useImageEffect'
import Heading from '@react/react-spectrum/Heading'
import IconLayers from '@react/react-spectrum/Icon/Layers'
import { Image } from '@react/react-spectrum/Image'
import { EasybakeContext } from '../EasybakeProvider'
import Link from '../Nav/Link'
import Spinner from '../Nav/Spinner'
import { __ } from 'i18n-for-browser'
import '../../config/i18n'
import CodeSnippet from '../Nav/CodeSnippet'
import ImageWait from '../Nav/ImageWait'
import code from '../../asset/code/smartobject.txt'
import MultilineText from '../Nav/MultilineText'
import CacheMultilineText from '../Nav/CacheMultilineText'

export default function SmartObject () {
    const { spinnerTimeout, group, wait } = useContext(EasybakeContext)
    const { beforeImage, afterImage } = useImageEffect({ group: 'smartobject' })
    const caption = `${__('smartobject_applying')}\u2026` // suffixed by a horizontal ellipse
    const prevImageSet = usePrevious({ beforeImage, afterImage })
    const descriptionKey = 'smartobject_desc'

    return (
        <div className="adobe-easybake-main-pane">
            <div className="adobe-easybake-main adobe-easybake-smartobject">
                <CacheMultilineText localizationKey={descriptionKey}/>
                <div className="adobe-easybake-file-info">
                    <div className="adobe-easybake-icon-image-container">
                        <IconLayers className="adobe-easybake-icon-image" size="S" />
                    </div>
                    <div className="adobe-easybake-file-name">{__('smartobject_image_title')}</div>
                </div>
                <div className="adobe-easybake-image-preview">
                    {group === 'smartobject' && wait &&
                        <React.Fragment>
                            <Image className="adobe-easybake-original-img" src={prevImageSet.afterImage} alt="processed img"/>
                            <Spinner timeout={spinnerTimeout} caption={caption} className="spinner"/>
                        </React.Fragment>
                    }
                    {group === 'smartobject' && !wait &&
                        <ImageWait caption={caption} className="adobe-easybake-original-img" src={afterImage} alt="original img"/>
                    }
                    {!group &&
                        <ImageWait caption={`${__('loading_image')}\u2026`} className="adobe-easybake-original-img" src={beforeImage} alt="original img"/>
                    }
                </div>
                {group === 'smartobject' && !wait &&
                    <div className="adobe-easybake-api-detail">
                        <div className="adobe-easybake-code-preview">
                            <CodeSnippet language="json" url={code}/>
                        </div>
                        <div className="adobe-easybake-desc">
                            <Heading variant="subtitle2">{__('smartobject_title')}</Heading>
                            <MultilineText localizationKey={descriptionKey}/>
                            <Link className="adobe-easybake-desc-link" referrer={`documentation:${group}:main`} label={__('link_doc')} url={__('url_doc_smartobject')} />
                        </div>
                    </div>
                }
            </div>
        </div>
    )
}
